export default __webpack_public_path__ + "static/media/banner_srpbs.ca519813.gif";